// @ts-nocheck
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Image, Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers/rootReducer";
import MyAccountButton from "./MyAccountButton";
import "./css/Header.scss";
import LanguageList from "./LanguageList";
import { Trans, useTranslation } from "react-i18next";
import { goTo } from "../utilities/utils";
import { useI18next } from "gatsby-plugin-react-i18next";
import { goToPlansWithParams } from "../utilities/utils";
const Header: React.FC = () => {
  let routeDetails = useSelector((state: RootState) => {
    return state.route;
  });

  const [esimLink, setEsimLink] = useState("https://esim.gophonebox.com/");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.size > 0) {
      const affiliateEsimLink =
        "https://esim.gophonebox.com/?" + params.toString();
      setEsimLink(affiliateEsimLink);
    } else if (sessionStorage.getItem("raLink")) {
      setEsimLink("https://esim.gophonebox.com/?bn=4036");
    }
  }, []);

  const { t } = useTranslation();
  const { language } = useI18next();
  // due to development constraints, these languages are only partially supported
  const specialLanguages = ["jp", "zh", "vi", "pt", "ko"];
  const isSpecialLanguage = specialLanguages.includes(language);

  const activationTextForDisplay = isSpecialLanguage ? (
    "Activation"
  ) : (
    <Trans>Activation</Trans>
  );
  const esimTextForDisplay = isSpecialLanguage ? "eSIM" : <Trans>eSIM</Trans>;
  const globalEsimTextForDisplay = isSpecialLanguage ? (
    "Global eSIM"
  ) : (
    <Trans>Global eSIM</Trans>
  );

  return (
    <>
      <div
        style={{
          backgroundColor: `${
            routeDetails.routeString === "partners" ? "#005068" : "#0494ca"
          }`,
          transition: "all 0.3s ease",
        }}
      >
        <PartnerContainer>
          <PartnerWrapper path={routeDetails.routeString} matchPath="partners">
            <PersonalNavItem
              path={routeDetails.routeString}
              noMatchPath="partners"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                goTo("/");
              }}
            >
              {t("Personal")}
            </PersonalNavItem>
            |
            <PartnerNavItem
              path={routeDetails.routeString}
              matchPath="partners"
              href="/partners"
              onClick={(e) => {
                e.preventDefault();
                goTo("/partners", undefined, undefined, true);
              }}
            >
              {t("Partner")}
            </PartnerNavItem>
          </PartnerWrapper>
          <div className="language-list-container">
            <LanguageList
              mainPage
              color={"#ffffff"}
              border={"1px solid #ffffff"}
            />
          </div>
        </PartnerContainer>
      </div>
      <Wrapper>
        <Container>
          <NavWrapper>
            <Logo>
              <a
                onClick={() => {
                  goTo("/", undefined, undefined, true);
                }}
              >
                <Image
                  src="/images/logo.png"
                  width="220px"
                  alt="PhoneBox Logo"
                />
              </a>
            </Logo>
            <div className="d-flex flex-row justify-content-center align-items-center">
              {/* canada plan  */}
              {routeDetails.routeString === "partners" ? (
                <div style={{ width: "125px" }}></div>
              ) : (
                <NavItem
                  path={routeDetails.routeString}
                  matchPath="plans-canada"
                  onClick={() => goToPlansWithParams("ca")}
                >
                  <Image
                    src="/images/icon-plan-canada.png"
                    alt="Canada Plan"
                    width={20}
                    style={{ marginRight: 6 }}
                  />
                  Canada
                </NavItem>
              )}
              {/* us plan  */}
              {routeDetails.routeString === "partners" ? (
                <div style={{ width: "125px" }}></div>
              ) : (
                <NavItem
                  path={routeDetails.routeString}
                  matchPath="plans-us"
                  onClick={() => goToPlansWithParams("us")}
                >
                  <Image
                    src="/images/icon-plan-us.png"
                    alt="US Plan"
                    width={20}
                    style={{ marginRight: 6 }}
                  />
                  U.S.
                </NavItem>
              )}
              {/* global plan tab  - temporary link now*/}
              {routeDetails.routeString === "partners" ? (
                <div style={{ width: "125px" }}></div>
              ) : (
                <NavItem
                  ath={routeDetails.routeString}
                  matchPath="global-esim"
                  href="/global-esim"
                  onClick={(e) => {
                    e.preventDefault();
                    goTo("/global-esim", undefined, undefined, true);
                  }}
                >
                  <Image
                    src="/images/icon-plan-global.png"
                    alt="Global eSIM"
                    width={20}
                    style={{ marginRight: 6 }}
                  />
                  Global
                </NavItem>
              )}
              {/* activation tab  */}
              {routeDetails.routeString === "partners" ? (
                <div style={{ width: "125px" }}></div>
              ) : (
                <NavItem
                  path={routeDetails.routeString}
                  matchPath="activation"
                  href="/activation"
                  onClick={(e) => {
                    e.preventDefault();
                    goTo("/activation", undefined, undefined, true);
                  }}
                >
                  {activationTextForDisplay}
                </NavItem>
              )}
              {/* home internet tab  */}
              {routeDetails.routeString === "partners" ? (
                <div style={{ width: "125px" }}></div>
              ) : (
                <NavItem
                  path={routeDetails.routeString}
                  matchPath="home-internet"
                  href="/home-internet"
                  onClick={(e) => {
                    e.preventDefault();
                    goTo("/home-internet", undefined, undefined, true);
                  }}
                  style={{ position: "relative" }}
                >
                  {/* <BlackFridayDealsBubble showTriangle={true} /> */}
                  {/* <NavTag>
                    <Trans>NEW!</Trans>
                  </NavTag> */}
                  <Trans>Home Internet</Trans>
                </NavItem>
              )}
              {routeDetails.routeString === "partners" ? (
                <div style={{ width: "125px" }}></div>
              ) : (
                <NavItem
                  path={routeDetails.routeString}
                  matchPath="support"
                  href="/support"
                  onClick={(e) => {
                    e.preventDefault();
                    goTo("/support", undefined, undefined, true);
                  }}
                >
                  <Trans>Support</Trans>
                </NavItem>
              )}
            </div>
            <MyAccountButton
              partnerPortal={routeDetails.routeString === "partners"}
            />
          </NavWrapper>
        </Container>
      </Wrapper>
    </>
  );
};

const PartnerWrapper = styled.div<{ path: string; matchPath: string }>`
  background-color: ${(props) =>
    props.path === props.matchPath ? "#005068" : "#0494ca"};
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #fff;
  padding: 12px;
  padding-left: 0px;
  transition: all 0.3s ease;
  height: 52px;
`;

const PartnerContainer = styled.div`
  margin: auto;
  @media (min-width: 1400px) {
    max-width: 1320px;
  }
  @media (min-width: 1200px) and (max-width: 1400px) {
    max-width: 1140px;
  }
  @media (min-width: 992px) and (max-width: 1200px) {
    max-width: 960px;
  }
  @media (min-width: 768px) and (max-width: 992px) {
    max-width: 540px;
  }
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .language-list-container {
    padding: 8px;
  }
`;

const PartnerNavItem = styled.a<{ path: string; matchPath: string }>`
  padding: 0px 8px 0px 8px;
  font-size: 16px;
  color: #ffffff;
  &:hover {
    cursor: pointer;
    color: #eeeeee;
  }
  font-weight: ${(props) => (props.path === props.matchPath ? "500" : "300")};
`;

const PersonalNavItem = styled.a<{ path: string; noMatchPath: string }>`
  padding: 0px 8px 0px 8px;
  font-size: 16px;
  color: #ffffff;
  &:hover {
    cursor: pointer;
    color: #eeeeee;
  }
  font-weight: ${(props) => (props.path !== props.noMatchPath ? "500" : "300")};
`;

const Wrapper = styled.div`
  background-color: #fff;
  z-index: 999;
  padding: 30px 0px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
`;

const NavWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const NavTag = styled.div<{ color: string; right: string }>`
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 10px;
  background-color: ${(props) => (props.color ? props.color : "red")};
  color: #ffffff;
  padding-left: 4px;
  padding-right: 4px;
  text-align: center;
  border-radius: 4px;
`;

const NavItem = styled.a<{ path: string; matchPath: string }>`
  color: ${({ path, matchPath }) =>
    path && matchPath && path === matchPath ? "#0194ca" : "black"};
  border-bottom: ${({ path, matchPath }) =>
    path && matchPath && path === matchPath ? "2px solid #0194ca" : "none"};

  display: flex;
  align-items: center;
  white-space: nowrap;

  margin: 0px 40px;
  font-size: 16px;
  :hover {
    color: #0194ca;
    cursor: pointer;
    border-bottom: 2px solid #0194ca;
  }

  font-weight: 600;
  @media (min-width: 1200px) and (max-width: 1400px) {
    margin: 0px 25px;
    font-size: 18px;
  }
`;

const Logo = styled.div`
  :hover {
    cursor: pointer;
  }
`;
export default Header;
